import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CompanySummariesPaginated } from '../../Models/Models/Company/CompanySummariesPaginated';
import { FirmType } from '../../Constants/Enums/Domain/FirmType';
import { CompanyDetailSort } from '../../Constants/Enums/Domain/CompanyDetailSort';

declare var IS_RUNNING_IN_APP_POOL;

export class CompanySearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(CompanyId: string, CompanyName: string, FirmType: FirmType, FSAAuthorisationNumber: string, Network: string, Postcode: string, SortDescending: boolean, Start: number, Count: number, OrderBy: CompanyDetailSort, IncludeInactive: boolean): Promise<CompanySummariesPaginated, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/CompanySearch/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { CompanyId: CompanyId, CompanyName: CompanyName, FirmType: FirmType, FSAAuthorisationNumber: FSAAuthorisationNumber, Network: Network, Postcode: Postcode, SortDescending: SortDescending, Start: Start, Count: Count, OrderBy: OrderBy, IncludeInactive: IncludeInactive }

    return AjaxWrapper.get<CompanySummariesPaginated, any>(url, data);
  }
}

